// Google Analytics 4 helpers.
// The gtag.js script is loaded in /public/index.html; here we just push events.

export const GA_ID = "G-D3BSQ1SGXR";

function isReady() {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

/** Fire a manual page_view. Call this on every SPA route change. */
export function trackPageview(pathname) {
  if (!isReady()) return;
  window.gtag("event", "page_view", {
    page_path: pathname,
    page_location: window.location.href,
    page_title: document.title,
    send_to: GA_ID,
  });
}

/** Fire an arbitrary GA4 event. */
export function trackEvent(name, params = {}) {
  if (!isReady()) return;
  window.gtag("event", name, { send_to: GA_ID, ...params });
}

/** Common conversion events. */
export const track = {
  phoneCall: (location) => trackEvent("phone_call_click", { location }),
  whatsapp: (location) => trackEvent("whatsapp_click", { location }),
  leadSubmit: () => trackEvent("lead_form_submitted", { form: "richiedi_intervento" }),
};
